/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'becomeacustomer/become-a-customer-success-step2': {
    width: 16,
    height: 16,
    viewBox: '0 0 71.8 71.8',
    data: '<g _fill="none" _stroke="#262422" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" data-name="Group 6247" transform="translate(.9 .9)"><path pid="0" d="M32.67 46.67H42v14l14-14h9.33A4.67 4.67 0 0070 42V4.67A4.67 4.67 0 0065.33 0H28a4.67 4.67 0 00-4.67 4.67" data-name="Path 3069"/><circle pid="1" cx="9.33" cy="9.33" r="9.33" data-name="Ellipse 144" transform="translate(2.33 9.33)"/><path pid="2" d="M23.33 51.33v-7a11.67 11.67 0 10-23.33 0v7h4.67L7 70h9.33l2.34-18.67z" data-name="Path 3070"/><path pid="3" d="M54.56 15.01l-9.02 12.05a2.33 2.33 0 01-3.51.25l-4.67-4.67" data-name="Path 3071"/></g>'
  }
})
